import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Text, Icon } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';
const useStyles = createUseStyles(styles, 'FormDetails');

function FormDetails({ form, onEdit, onClose, ...props }) {
    const classes = useStyles();
    const { t } = useWeb5Context();
    const details = useMemo(() => {
        if (!form?.detail) return null;
        const sections = [];
        let rows = [];
        form.detail.forEach((el, i) => {
            if (el.type === 'title') {
                if (sections.length !== 0) {
                    rows = [];
                }
                sections.push(
                    <div key={i} className={classes.box}>
                        <div className={classes.boxHeader}>
                            <Text type="subtitle1" className={classes.boxTitle}>
                                {el.titleName}
                            </Text>
                        </div>
                        <div className={classes.boxContent}>{rows}</div>
                    </div>,
                );
            } else if (el.type === 'text') {
                if (sections.length === 0) {
                    sections.push(
                        <div key={i} className={classes.box}>
                            <div className={classes.boxHeader}></div>
                            <div className={classes.boxContent}>{rows}</div>
                        </div>,
                    );
                }
                rows.push(
                    <div key={i} className={classes.row}>
                        <Text className={classes.rowTitle}>{el.key}</Text>
                        <Text className={classes.rowText}>{el.value}</Text>
                    </div>,
                );
                if (i === form.detail.length) {
                    sections.push(rows);
                }
            }
        });
        return sections;
    }, [
        classes.box,
        classes.boxContent,
        classes.boxHeader,
        classes.boxTitle,
        classes.row,
        classes.rowText,
        classes.rowTitle,
        form,
    ]);

    return (
        <div className={classes.root}>
            <div className={classes.header}>
                <Icon name="close" onClick={onClose} className={classes.close} />
                <Text type="h6">{t('title_form_detail')}</Text>
                <span>
                    {onEdit && (
                        <Icon
                            name={form.readOnly ? 'visibilityOn' : 'edit'}
                            onClick={onEdit}
                            className={classes.edit}
                        />
                    )}
                </span>
            </div>
            <div className={classes.content}>{details}</div>
        </div>
    );
}

FormDetails.propTypes = {
    form: PropTypes.object.isRequired,
};

export default memo(FormDetails);
